import { mapActions, mapGetters } from 'vuex';
import ProductCard from '@/components/cards/ProductCard/index.vue';
import _ from 'lodash';
import { globalLoader } from '@/helpers/variables';

export default {
  name: 'Favorites',
  components: {
    ProductCard
  },
  mounted() {
    globalLoader(false);
  },
  computed: {
    ...mapGetters({
      favourites: 'favorites/whichList'
    }),
    favoritesProducts() {
      return _.map(this.favourites, 'product.data');
    }
  },
  methods: {
    ...mapActions({})
  }
};
